import { createSlice } from '@reduxjs/toolkit';
import { updateCart } from '../utils/cartUtils';

const initialState = localStorage.getItem('cart')
  ? JSON.parse(localStorage.getItem('cart'))
  : { cartItems: [], shippingAddress: {}, paymentMethod: 'PayPal' };

// Helper to compare variants safely
const isSameVariant = (a, b) => JSON.stringify(a || {}) === JSON.stringify(b || {});

const sanitizeItem = (item) => ({
  _id: item._id,
  name: item.name || 'Unnamed Product',
  image: item.image || '/images/placeholder.png',
  price: item.price ?? 0,
  qty: item.qty ?? 1,
  variant: item.variant || null,
});

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const payload = action.payload;

      const item = sanitizeItem(payload);

      const existItem = state.cartItems.find(
        (x) => x._id === item._id && isSameVariant(x.variant, item.variant)
      );

      if (existItem) {
        existItem.qty += item.qty;
      } else {
        state.cartItems.push(item);
      }

      return updateCart(state);
    },

    removeFromCart: (state, action) => {
      const { productId, variant } = action.payload;

      state.cartItems = state.cartItems.filter(
        (x) => !(x._id === productId && isSameVariant(x.variant, variant))
      );

      return updateCart(state);
    },

    updateQty: (state, action) => {
      const { productId, variant, qty } = action.payload;

      const item = state.cartItems.find(
        (x) => x._id === productId && isSameVariant(x.variant, variant)
      );

      if (item) {
        item.qty = qty ?? item.qty;
      }

      return updateCart(state);
    },

    saveShippingAddress: (state, action) => {
      state.shippingAddress = action.payload || {};
      localStorage.setItem('shippingAddress', JSON.stringify(state.shippingAddress));
    },

    savePaymentMethod: (state, action) => {
      state.paymentMethod = action.payload || 'PayPal';
      localStorage.setItem('cart', JSON.stringify(state));
    },

    clearCartItems: (state) => {
      state.cartItems = [];
      return updateCart(state);
    },

    resetCart: () => initialState,
  },
});

export const {
  addToCart,
  removeFromCart,
  updateQty,
  saveShippingAddress,
  savePaymentMethod,
  clearCartItems,
  resetCart,
} = cartSlice.actions;

export default cartSlice.reducer;